import type React from 'react'
import Skeleton from 'react-loading-skeleton'
import useCategoryTile from '@components/ApparelCollection/useCategoryTile'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import * as S from './CategoryTile.styles'

interface CategoryTileProps {
  handle: string
  className?: string
}

const CategoryTileSkeleton = () => (
  <S.CategoryTile>
    <S.ImageContainer>
      <Skeleton />
    </S.ImageContainer>
    <S.TextContainer>
      <S.Title>
        <Skeleton />
      </S.Title>
    </S.TextContainer>
  </S.CategoryTile>
)

export const CategoryTile: React.FC<CategoryTileProps> = ({
  handle,
  className,
}) => {
  const { loading, data, error } = useCategoryTile({
    variables: { handle },
  })

  if (loading) {
    return <CategoryTileSkeleton />
  }

  if (error || !data?.collection) {
    return null
  }

  const { collection } = data
  const squaredBannerImage = collection.squaredBannerImage?.reference as any
  const imageUrl = squaredBannerImage?.image?.url
  const collectionUrl = `/collections/${collection.handle}`

  return (
    <S.CategoryTile className={className}>
      <S.ImageContainer>
        <S.ImageLink href={collectionUrl}>
          {imageUrl ? (
            <S.Image
              lqip
              lazyload
              alt={collection.title}
              sizes="(min-width: 768px) 20vw, 70vw"
              imgSrc={setQueryParams(imageUrl, [
                { name: 'width', value: '30' },
              ])}
              sources={buildIntrinsicWidthSources({
                src: imageUrl,
              })}
            />
          ) : (
            <S.ImagePlaceholder />
          )}
        </S.ImageLink>
      </S.ImageContainer>
      <S.TextContainer>
        <S.TitleLink href={collectionUrl}>
          <S.Title>{collection.title}</S.Title>
        </S.TitleLink>
      </S.TextContainer>
    </S.CategoryTile>
  )
}
